(function() {
  'use strict';

  function initVideoCards() {
    document.querySelectorAll('.eq-video-card').forEach(card => {
      const poster = card.querySelector('.eq-video-poster');
      const video = card.querySelector('video');

      if (!video || !poster) return;

      let isPlaying = false;
      const isMobile = window.innerWidth <= 768;

      // Ensure video is properly set up for mobile
      if (isMobile) {
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
      }

      // Desktop hover
      card.addEventListener('mouseenter', () => {
        if (!isMobile) {
          poster.style.display = 'none';
          video.play().catch(err => console.log('Play failed:', err));
          isPlaying = true;
        }
      });

      card.addEventListener('mouseleave', () => {
        if (!isMobile) {
          video.pause();
          video.currentTime = 0;
          poster.style.display = 'block';
          isPlaying = false;
        }
      });

      // Mobile tap toggle
      card.addEventListener('click', (e) => {
        if (isMobile) {
          const clickedElement = e.target;
          
          // Only handle video toggle if not clicking on a link
          if (!clickedElement.closest('a')) {
            e.preventDefault();
            e.stopPropagation();

            if (isPlaying) {
              video.pause();
              video.currentTime = 0;
              poster.style.display = 'block';
              isPlaying = false;
            } else {
              poster.style.display = 'none';
              video.play().catch(err => {
                console.log('Play failed:', err);
                poster.style.display = 'block';
              });
              isPlaying = true;
            }
          }
        }
      });

      // Handle visibility change (when user switches tabs)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && isPlaying) {
          video.pause();
          if (isMobile) {
            poster.style.display = 'block';
            isPlaying = false;
          }
        }
      });
    });
  }

  // Initialize on window load
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initVideoCards);
  } else {
    // DOM already loaded
    initVideoCards();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', initVideoCards);

})();